/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {STACK_VIEW_DIRECTIVES} from './index';
export class ClrStackViewModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule, FormsModule], declarations: [STACK_VIEW_DIRECTIVES], exports: [STACK_VIEW_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrStackViewModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrStackViewModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrStackViewModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
